/* ppz-sticky-cta.js — la barra col pulsante che resta attaccata in fondo.
 *
 * Compare quando il pulsante della testata e' passato sopra lo schermo, e
 * sparisce quando si arriva alla sezione dove si compra: li' coprirebbe
 * proprio i pulsanti che deve far raggiungere.
 *
 * Contratto:
 *   [data-ppz-sticky]        la barra
 *   [data-ppz-sticky-after]  il pulsante della testata: e' il confine
 *   #ppz-offerta             la sezione dell'offerta
 *   [data-ppz-cta-inline]    i pulsanti in mezzo alla pagina: con uno di loro
 *                            sullo schermo la barra si nasconde
 *
 * CHI SCORRE NON E' SEMPRE LA FINESTRA. Il tema Horizon mette overflow:hidden
 * su html e body e fa scorrere .page-wrapper, ma non su tutte le pagine e non
 * a tutte le larghezze. Per questo non si prova a indovinare il contenitore:
 * si ascolta in fase di cattura sul documento, che prende lo scorrimento di
 * chiunque.
 *
 * Si legge la posizione con getBoundingClientRect a ogni scorrimento invece di
 * usare IntersectionObserver: qui serve sapere se il pulsante e' passato SOPRA
 * o non e' ancora arrivato, e la differenza fra i due casi con l'osservatore va
 * ricavata a mano lo stesso. Il conto e' due letture, non pesa.
 */
(function () {
  function init(bar) {
    if (bar.dataset.ppzSticky === 'ready') return;
    bar.dataset.ppzSticky = 'ready';

    var after = document.querySelector('[data-ppz-sticky-after]');
    var offer = document.querySelector('#ppz-offerta');
    var inline = document.querySelectorAll('[data-ppz-cta-inline]');

    /* Senza il pulsante della testata non c'e' un confine da superare: la barra
       resterebbe accesa sempre, anche in cima. Meglio lasciarla giu'. */
    if (!after) return;

    function update() {
      var h = window.innerHeight || document.documentElement.clientHeight;

      /* Passato: il pulsante e' uscito dal bordo ALTO dello schermo. */
      var passed = after.getBoundingClientRect().bottom < 0;

      /* Sull'offerta: la sezione e' entrata per piu' di un terzo di schermo e
         non e' ancora uscita in alto. */
      var onOffer = false;
      if (offer) {
        var r = offer.getBoundingClientRect();
        onOffer = r.top < h * 0.66 && r.bottom > 0;
      }

      /* Un pulsante in mezzo alla pagina sullo schermo (29/09/2026, sezione
         ppz-adv-cta): la barra si nasconde, cosi' non se ne vedono mai due
         insieme. Basta che se ne veda un pezzo. */
      var onInline = false;
      for (var i = 0; i < inline.length && !onInline; i++) {
        var b = inline[i].getBoundingClientRect();
        onInline = b.bottom > 0 && b.top < h;
      }

      bar.classList.toggle('is-on', passed && !onOffer && !onInline);
    }

    /* Si ascolta in FASE DI CATTURA sul documento: cosi' si intercetta lo
       scorrimento di QUALUNQUE contenitore, non solo della finestra. Serve
       perche' l'evento "scroll" di un elemento non risale ai genitori: se ci si
       mettesse in ascolto solo sulla finestra, con lo scorrimento dentro
       .page-wrapper non arriverebbe niente. E non si puo' nemmeno decidere una
       volta per tutte chi scorre: dipende dalla pagina e dalla larghezza. */
    document.addEventListener('scroll', update, { passive: true, capture: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    /* Utile alle prove e a chi cambia sezione dall'editor. */
    bar.ppzUpdate = update;
  }

  /* Salto morbido per i collegamenti che puntano dentro la pagina.

     PERCHE' NON BASTA UNO scrollIntoView. Fra la testata e le confezioni ci
     sono foto che il browser carica solo quando servono. Al primo clic quelle
     foto non hanno ancora un'altezza: il browser calcola dove sta la sezione,
     parte, e mentre la pagina scorre le foto arrivano e spingono tutto piu' in
     giu'. Si finisce sulla sezione PRIMA di quella giusta — ed e' proprio la
     prima volta che si entra, cioe' quando le foto non sono ancora nella
     memoria del browser.

     Qui si scorre, si aspetta che l'animazione finisca e si ricontrolla dove si
     e' arrivati: se il bersaglio si e' spostato, si corregge. Al massimo tre
     tentativi, per non inseguire all'infinito una pagina che non sta ferma. */
  /* PRIMA SI CARICANO LE FOTO, POI SI SCORRE.

     Correggere dopo non bastava: si vedeva la pagina fermarsi alla sezione
     sbagliata e poi ripartire, due movimenti invece di uno. La causa e' che le
     foto fra la testata e le confezioni si caricano solo quando servono, quindi
     al momento del clic non hanno ancora un'altezza e il bersaglio e' piu' in
     alto di dove finira'.

     Qui le foto che stanno SOPRA il bersaglio vengono caricate subito, si
     aspetta che abbiano preso la loro altezza (al massimo mezzo secondo, per non
     lasciare il dito a vuoto) e solo allora si scorre, una volta sola. Se
     nonostante tutto il bersaglio si sposta ancora, l'aggiustamento finale e'
     uno scatto secco e non una seconda scorsa: si nota molto meno. */
  function vaiA(el) {
    var mancanti = Array.prototype.filter.call(
      document.querySelectorAll('img'),
      function (img) {
        if (img.complete) return false;
        /* solo quelle sopra al bersaglio: le altre non spostano niente */
        return img.getBoundingClientRect().top < el.getBoundingClientRect().top;
      }
    );

    if (!mancanti.length) return scorri();

    var partito = false;
    var restanti = mancanti.length;

    mancanti.forEach(function (img) {
      img.loading = 'eager';
      img.addEventListener('load', fatta, { once: true });
      img.addEventListener('error', fatta, { once: true });
    });

    /* Non si aspetta all'infinito: se la rete e' lenta si parte lo stesso. */
    var attesaMassima = window.setTimeout(parti, 500);

    function fatta() { restanti--; if (restanti <= 0) parti(); }

    function parti() {
      if (partito) return;
      partito = true;
      window.clearTimeout(attesaMassima);
      scorri();
    }

    function scorri() {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.setTimeout(function () {
        var atteso = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
        var dove = el.getBoundingClientRect().top;
        var inFondo = window.innerHeight + window.scrollY >= document.body.scrollHeight - 2;
        if (!inFondo && Math.abs(dove - atteso) > 8) {
          el.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }, 650);
    }
  }

  function smooth(e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id === '#') return;
    var el = document.querySelector(id);
    if (!el) return;
    e.preventDefault();
    vaiA(el);
  }

  function boot() {
    document.querySelectorAll('[data-ppz-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('click', smooth);
  document.addEventListener('shopify:section:load', boot);
})();
